import { ApiResourceBaseClass as e } from "./baseApiCalls.js";
const a = "reviews/retroactive_tag";
class o extends e {
  async startRetroactiveTags(t) {
    const { data: s } = await this.post(a, t);
    return s;
  }
  async getRetroactiveTagsStatus() {
    const { data: t } = await this.get(`${a}/status`);
    return t;
  }
}
export {
  o as ReviewRetroactiveTags
};
